var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ak-login-content"},[_c('section',[_c('TheForm')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }